import { useState } from "react";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import SmallPopupWithInput from "../../../_utils/CommonSmallPopupWithInput";

/* 
headerTitle - Title displayed in the popup header
bulletPoints - List of bullet points displayed in the popup
declineReason -  Stores the reason entered for declining the beneficiary account
showLoader - Controls the loading state during the decline action
handleClosePopup - Function to close the popup
handleFunctionClick -  Function executed when the user confirms the decline action
*/

const BeneAccountDeclinePopup = ({
  headerTitle,
  bulletPoints,
  declineReason,
  setDeclineReason,
  showLoader,
  handleClosePopup,
  handleFunctionClick,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration?.lengthCheckZero) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };

  return (
    <>
      {" "}
      <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
        <SmallPopupWithInput
          headerTitle={headerTitle}
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          textSize="font-md"
          secondHeaderTitle={globalText?.REJECT_POPUP_SUB_TEXT}
          secondHeaderFontColor="text-secondary"
          noteText={globalText?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
          bulletPoints={bulletPoints}
          secondHeaderTextSize="font-xs"
          secondHeaderFontWeight="normal"
          noteColor="text-secondary"
          inputPlaceholder={globalText?.REASON}
          inputVariant={computeVariant(declineReason, isFocused)}
          inputOnFocus={(e) => setIsFocused(true)}
          inputOnBlur={(e) => setIsFocused(false)}
          inputIsDisabled={showLoader ? true : false}
          btnOneIsDisabled={showLoader ? true : false}
          inputBgColor="var(--primary-bg)"
          inputFgColor="var(--text-secondary)"
          inputOnInput={(e) => {
            if (!showLoader) {
              handleInputChange(e);
            }
          }}
          inputValue={declineReason}
          inputFontKind="small"
          inputIsFullWidth={true}
          btnOneText={globalText?.CANCEL}
          btnOneHandleFunction={() => {
            if (!showLoader) {
              handleClosePopup();
            }
          }}
          btnOneEnabledBgColor="var(--primary-bg)"
          btnOneOutLineColor="var(--text-primary)"
          btnOneEnabledTextColor="var(--text-primary)"
          btnOneHoverOption="white"
          btnTwoText={globalText?.REJECT}
          btnTwoHandleFunction={handleFunctionClick}
          btnTwoEnabledBgColor="var(--negative-act)"
          btnTwoEnabledTextColor="var(--text-primary)"
          btnTwoIsDisabled={
            !declineReason ||
            declineReason.length < GlobalConfiguration?.panLength
          }
          btnTwoDisabledBgColor="var(--text-disabled)"
          btnTwoIsLoaderNeeded={showLoader ? true : false}
          btnTwoIsLoading={showLoader ? true : false}
          btnTwoHoverOption="black"
          btnTwoInActiveVariantNeeded={true}
        />
      </div>
    </>
  );
};

export default BeneAccountDeclinePopup;
